import {
  SupabaseServiceView,
  assertNoNullFields,
} from "../../../server/supabase/base-supabase-service";

import type { Database } from "../../../__definitions__/database-definitions";

export type ConnectionKey = Database["public"]["Views"]["connection_key"]["Row"];

export interface ConnectionCategoryBase {
  key: string;
  display_name: string;
}
// Assert that the object is a ConnectionCategoryBase
function isConnectionCategory(obj: unknown): obj is ConnectionCategoryBase {
  return Boolean(obj) && typeof obj === "object" && "key" in obj! && "display_name" in obj;
}

export class SupabaseConnectionKeysService extends SupabaseServiceView<"connection_key"> {
  table = "connection_key" as const;

  async getCategories(): Promise<ConnectionCategoryBase[]> {
    try {
      const { data } = await this.getAll(null, {
        order: [{ column: "key", dir: "asc" }],
      });
      assertNoNullFields(data);
      // The display name is eventually stored in the DB as the user can customise it.
      const categoriesRaw = (data || []).map(({ display_name, key }) => ({
        key,
        display_name,
      }));

      return categoriesRaw.filter(isConnectionCategory);
    } catch (error) {
      console.error("Error loading connection categories", error);
      return [];
    }
  }
}
